<div>
  @for (entry of _service.dialogs(); track entry.id) {
    <!--
      Full-screen overlay per dialog (stacks naturally via DOM order).

      Responsive layout:
        - mobile  (<sm)  : bottom-sheet, full-width, slides up from the bottom
        - tablet  (≥sm)  : centered card with sensible max-width
        - desktop (≥md)  : centered card, content respects styleClass overrides
    -->
    <div
      class="fixed inset-0 z-1200 flex items-center justify-center overflow-y-auto overscroll-contain p-0 sm:p-4"
      role="dialog"
      aria-modal="true"
    >
      <!-- Backdrop -->
      @if (entry.config.modal !== false) {
        <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
        <div
          class="absolute inset-0 bg-black/50"
          (click)="onBackdropClick(entry)"
        ></div>
      }

      <!-- Dialog box -->
      <div
        class="relative flex min-h-0 flex-col bg-white shadow-2xl overflow-hidden w-full max-h-[95dvh] rounded-xl sm:w-auto sm:max-w-[95vw] sm:max-h-[90dvh]"
        [ngClass]="entry.config.styleClass"
      >
        <!-- Optional header bar -->
        @if (entry.config.showHeader !== false && entry.config.header) {
          <div class="flex items-center justify-between px-4 py-3 shrink-0 sm:px-6 sm:py-4">
            <span class="text-base font-semibold text-secondary sm:text-lg">{{ entry.config.header }}</span>
            @if (entry.config.closable !== false) {
              <button
                type="button"
                class="flex items-center justify-center size-8 rounded-md text-secondary cursor-pointer hover:bg-surface-100 transition-colors border-none bg-transparent"
                (click)="entry.ref.close()"
                aria-label="Close"
              >
                <i class="pi pi-times text-sm"></i>
              </button>
            }
          </div>
        }

        <!-- Content area — overflow-y-auto so tall modals scroll internally -->
        <div
          class="min-h-0 flex-1 overflow-y-auto px-4 pt-3 pb-4 overscroll-contain sm:px-6 sm:pt-4 sm:pb-6"
          [ngStyle]="entry.config.contentStyle ?? null"
        >
          <ng-container
            [ngComponentOutlet]="entry.component"
            [ngComponentOutletInjector]="entry.injector"
          />
        </div>
      </div>
    </div>
  }
</div>
